module.exports = {
  PURCHASEORDER_PREVIEW: '/purchaseorder/preview'
}
